import { FC, MouseEvent } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";
import Typography from "../../typography/Typography";

import { BidButtonProps } from "./BidButton.types";
import StyledBidButton, { StyledBidButtonLabel } from "./BidButton.styles";

const BidButton: FC<BidButtonProps> = ({
	className,
	bidValue,
	totalValue,
	currencySymbol = "£",
	onClick,
	...props
}) => {
	const block = new BemIt("BidButton");

	const formattedTotalValue = totalValue
		? totalValue.toLocaleString()
		: "--,---";
	const formattedBidValue = bidValue ? bidValue.toLocaleString() : "---";

	const totalLabel = `${currencySymbol}${formattedTotalValue}`;
	const bidLabel = `Bid ${currencySymbol}${formattedBidValue}`;

	const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
		if (onClick) onClick(event);
	};

	return (
		<StyledBidButton
			className={addClass(className).after(block)}
			onClick={handleClick}
			{...props}
		>
			<StyledBidButtonLabel>
				<Typography weight="heaviest" variant="body-large">
					{totalLabel}
				</Typography>
				<Typography weight="heaviest" variant="body">
					{bidLabel}
				</Typography>
			</StyledBidButtonLabel>
		</StyledBidButton>
	);
};

export default BidButton;
